module.exports = __webpack_public_path__ + "static/media/corporate_contact.c7c05428.png";